import React, { forwardRef } from 'react';
import { CustomObject } from '../../../types/data';
import { getSpaceType } from '../../../common/utils';
import VideoSpace from './video-space';
import PhotoSpace from './photo-space';
import { MathUtils } from 'three';
import { ReactThreeFiber } from 'react-three-fiber';

const { degToRad } = MathUtils;

type TSpaceProps = React.Props<{}> & {
  data: CustomObject;
  radius?: number;
  renderOrder?: number;
  enableAnimation?: boolean;
  resourceId?: string;
  type?: 'env' | 'cube';
  onLoad?: () => void;
};

const getComponent = (pointType: ReturnType<typeof getSpaceType>) => {
  if (pointType === 'video') {
    return VideoSpace;
  } else if (pointType === 'photo') {
    return PhotoSpace;
    // return PhotoCubeSpace;
  }
  return () => null;
};

const Space = forwardRef(
  ({ data, renderOrder, type, enableAnimation, radius = 50, resourceId, onLoad }: TSpaceProps, ref) => {
    const pointType = getSpaceType(data);
    const Component = getComponent(pointType);

    let rotation: ReactThreeFiber.Euler = [0, 0, 0];

    if (pointType === 'video') {
      rotation = [0, degToRad(90), 0];
    }

    return (
      // @ts-ignore TODO: fix this
      <group ref={ref}>
        <Component
          radius={radius}
          renderOrder={renderOrder}
          enableAnimation={enableAnimation}
          rotation={rotation}
          data={data}
          resourceId={resourceId}
          type={type}
          onLoad={onLoad}
        />
      </group>
    );
  }
);

export default Space;
